export const READ_FUNDING_DETAILS = 'READ_FUNDING_DETAILS';
export const COMMIT_WITHDRAW_ORDER = 'COMMIT_WITHDRAW_ORDER';
export const READ_REFUND_WITHDRAW_ORDER = 'READ_REFUND_WITHDRAW_ORDER';
export const READ_REFUND_APPROVE_LIST = 'READ_REFUND_APPROVE_LIST';
export const APPROVE_REFUND_WITHDRAW_ORDER = 'APPROVE_REFUND_WITHDRAW_ORDER';

export const READ_FUNDING_WALLET_LIST = 'READ_FUNDING_WALLET_LIST';

export const READ_FUNDING_WALLET_TXN = 'READ_FUNDING_WALLET_TXN';
export const OPERATION_REFUND_RETRY_ORDER = 'OPERATION_REFUND_RETRY_ORDER';